<template>
	<div class="page-dealers-projects">
		<app-table
			class="mt-3 is-not-selectable"
			name="implementers"
			:columns="columns"
			:rows="rows"
			:current-page="currentPage"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable"
				v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.description }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.projectCode }}
				</td>
				<td class="switch-assign">
					<div @click="openModal(props.row)">
						<v-switch
							class="mt-0"
							color="info"
							hide-details
							:label="labelState(props.row.flagAssigned)"
							v-model="props.row.flagAssigned"
						></v-switch>
					</div>
				</td>
				<td>
					<app-tooltip-button
						:disabled="!props.row.flagAssigned"
						:class="{ 'company-disabled': !props.row.flagAssigned }"
						v-if="props.row.flagCompanyParent"
						color="primary"
						icon="location_city"
						text="Compañías maestras"
						@click-icon="masterCompanies(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			confirmation-text="Aceptar"
			:show-modal="modalConfirmation.value"
			:text="modalContent"
			@cancel="cancelModal"
			@confirm="confirm"
		/>
		<router-view></router-view>
	</div>
</template>
<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function created() {
	this.projectList();
}

async function projectList() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 20,
		isSelected: 2,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/projects`, { params });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function assignmentDist(project) {
	const options = {
		1: this.assignRow,
		0: this.deallocateButton,
	};
	options[Number(project.flagAssigned)].call(this, project);
}

async function deallocateButton(project) {
	const projectIds = [project.id];
	const body = { projectIds };
	try {
		await this.$http.delete(`distributaries/${this.id}/projects`, { data: body });
		this.showNotification('El proyecto fue desasignado correctamente');
	} catch (error) {
		this.$set(project, 'flagAssigned', !project.flagAssigned);
		this.showError();
	}
	this.cancelModalConfirmation();
}

async function assignRow(project) {
	const projectIds = [project.id];
	const body = { projectIds };
	try {
		await this.$http.post(`distributaries/${Number(this.id)}/projects`, body);
		this.showNotification('El proyecto fue asignado correctamente');
	} catch (error) {
		this.$set(project, 'flagAssigned', !project.flagAssigned);
		this.showError();
	}
	this.cancelModalConfirmation();
}

function beforeRouteLeave(to, from, next) {
	const pathTo = to.path;
	const pathFrom = from.path;
	if (pathTo === pathFrom && to.name !== from.name) {
		next({ name: 'page-configuration' });
	} else {
		next();
	}
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
}

function labelState(assigned) {
	return assigned ? 'Asignado' : '';
}

function masterCompanies(project) {
	const { codeProject } = project;
	this.$router.push({ name: 'assignment-master-companies', params: { codeProject } });
}

function confirm() {
	this.assignmentDist(this.currentProject);
}

function modalContent() {
	const project = this.currentProject && this.currentProject.name;
	const distributer = this.$route.params.name;
	return `¿Desea asignar el proyecto ${project} al distribuidor ${distributer}?`;
}

function cancelModal() {
	const { flagAssigned } = this.currentProject;
	this.currentProject.flagAssigned = !flagAssigned;
	this.cancelModalConfirmation();
}

function openModal(project) {
	this.currentProject = project;
	this.openModalConfirmation();
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', visible: true },
			{ id: 2, name: 'Descripción', visible: true },
			{ id: 3, name: 'Código del proyecto', visible: true },
			{ id: 4, name: 'Asignar', visible: true },
			{ id: 5, name: 'Acciones', visible: true },
		],
		currentPage: 1,
		currentProject: null,
		lastPage: 0,
		params: {
			page: 1,
			search: null,
		},
		rows: [],
	};
}

export default {
	name: 'page-dealers-projects',
	beforeRouteLeave,
	components: {
		appTooltipButton,
		appConfirmationModal,
	},
	computed: {
		modalContent,
	},
	created,
	data,
	methods: {
		assignmentDist,
		assignRow,
		cancelModal,
		changePage,
		confirm,
		deallocateButton,
		labelState,
		masterCompanies,
		onSearch,
		openModal,
		projectList,
	},
	props: {
		id: {
			type: [Number, String],
		},
		name: {
			type: String,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.page-dealers-projects {
	padding: 80px 50px 0;
}

.switch-assign {
	width: 120px;
}

.company-disabled {
	opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-dealers-projects.vue